const localStorageKey = 'fl_wishlist';

// Shopify resize image (helper function)
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba
const egWishlistResizeImageHelper = (src, size, crop = '') =>
  src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
      if (crop.length) {
        // eslint-disable-next-line no-param-reassign
        crop = `_crop_${crop}`;
      }
      return `_${size}${crop}${match}`;
    });

// Shopify format money (helper function)
// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
const egWishlistFormatMoneyHelper = (cents, format) => {
  if (typeof cents === 'string') {
    // eslint-disable-next-line no-param-reassign
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    // eslint-disable-next-line no-param-reassign
    precision = defaultOption(precision, 2);
    // eslint-disable-next-line no-param-reassign
    thousands = defaultOption(thousands, ',');
    // eslint-disable-next-line no-param-reassign
    decimal = defaultOption(decimal, '.');

    if (Number.isNaN(number) || number == null) {
      return 0;
    }

    // eslint-disable-next-line no-param-reassign
    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    // eslint-disable-next-line prefer-template
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    // eslint-disable-next-line no-param-reassign
    cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  // eslint-disable-next-line default-case
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Init Wishlist
const initWishlist = () => {
  const wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];

  document.querySelectorAll('.button-add-remove-wishlist').forEach((btn) => {
    const productHandle = btn.closest('[data-product-handle]')?.dataset.productHandle;

    const isWishlisted = wishlist.some((elem) => elem.handle === productHandle);

    if (isWishlisted) {
      btn.querySelector('[data-add]').style.display = 'none';
      btn.querySelector('[data-remove]').style.display = 'inline-flex';
    } else {
      btn.querySelector('[data-add]').style.display = 'inline-flex';
      btn.querySelector('[data-remove]').style.display = 'none';
    }

    btn.classList.remove('hidden');
  });

  document.querySelectorAll('.wishlist-count-bubble').forEach((bubble) => {
    if (wishlist.length === 0) {
      bubble.style.display = 'none';
    } else {
      bubble.style.display = 'flex';
      bubble.textContent = wishlist.length;
    }
  });

  document.querySelectorAll('.js-wishlist-items-quantity').forEach((qty) => {
    if (wishlist.length === 0) {
      qty.style.display = 'none';
    } else {
      qty.style.display = 'inline';
      qty.textContent = wishlist.length;
    }
  });
};
initWishlist();

// Wishlist Buttons
window.onClickEgWishlistButton = async (btn, event) => {
  event.preventDefault();

  const productHandle = btn.closest('[data-product-handle]')?.dataset.productHandle;

  let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  const isWishlisted = wishlist.some((elem) => elem.handle === productHandle);

  if (isWishlisted) {
    wishlist = wishlist.filter((elem) => elem.handle !== productHandle);
  } else {
    const response = await fetch(`/products/${productHandle}.js`);
    const product = await response.json();

    let alt_featured_image_position = 0;
    product.media.forEach((item, index) => {
      if (item.alt === 'Women') {
        alt_featured_image_position = index - 1;
      }
    })

    wishlist.push({
      id: product.id,
      handle: productHandle,
      url: product.url,
      title: product.title,
      compare_at_price: product.compare_at_price,
      compare_at_price_variese: product.compare_at_price_varies,
      price: product.price,
      price_min: product.variants[0].price,
      price_max: product.variants[product.variants.length - 1].price,
      featured_image: product.featured_image,
      image_over: product.images[1],
      alt_featured_image: product.images[alt_featured_image_position],
      alt_image_over: product.images[alt_featured_image_position + 1],
      vendor: product.vendor,
      variants: product.variants,
      tags: product.tags,
      time: Date.now(),
    });

    let popupWishlistWrapper = document.querySelector('.popup-wishlist-wrapper')
    popupWishlistWrapper.insertAdjacentHTML('afterbegin', `
      <div class="popup popup-wishlist">
        <div class="popup__desktop">
          <h3 class="popup__heading">Added to wishlist</h3>
          <div class="popup__products js-popup-products">
            <div class="popup__product">
              <div
                style="
                  background-image: url(${product.featured_image});
                "
                class="popup__image"
              ></div>
    
              <div class="popup__desc">
                <div class="popup__title">
                  ${product.title}
                </div>
                <div class="popup__price">${egWishlistFormatMoneyHelper(product.price)}</div>
              </div>
            </div>
          </div>
          <a
            href="/pages/wishlist"
            class="popup__btn"
          >
            <span class="btn__icon icon icon--heart icon--beige-stroke">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18 18" style="enable-background:new 0 0 18 18;" xml:space="preserve">
                <g class="heart-icon-wrap">
                  <path class="icon__path" d="M9,16.1c-0.2,0-0.3-0.1-0.4-0.2L3,10.6c-0.1,0-0.1-0.1-0.2-0.2s-0.3-0.3-0.5-0.6C2.1,9.5,1.9,9.2,1.7,8.9
                    S1.3,8.3,1.2,7.8C1.1,7.4,1,7,1,6.6c0-1.3,0.4-2.3,1.1-3.1c0.8-0.7,1.8-1.1,3.1-1.1c0.4,0,0.7,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1.1,0.5
                    c0.3,0.2,0.6,0.4,0.9,0.6C8.6,3.9,8.8,4.1,9,4.4c0.2-0.2,0.4-0.4,0.7-0.6c0.2-0.2,0.5-0.4,0.9-0.6c0.3-0.2,0.7-0.4,1.1-0.5
                    c0.4-0.1,0.8-0.2,1.1-0.2c1.3,0,2.4,0.4,3.1,1.1C16.6,4.3,17,5.3,17,6.6c0,1.3-0.7,2.7-2,4L9.4,16C9.3,16.1,9.2,16.1,9,16.1z"></path>
                </g>
              </svg>
            </span>
            Show my wishlist
          </a>
        </div>
        <div class="popup__mobile">
          <span class="popup__mobile-text">Product added to wishlist</span>
          <a
            href="/pages/wishlist"
            class="popup__mobile-link"
          >
            Show
          </a>
        </div>
      </div>
    `)
    setTimeout(() => {
      let popupWishlist = popupWishlistWrapper.querySelectorAll('.popup-wishlist')
      popupWishlist[0].classList.add("is-visible", "is-slided")
      popupWishlist.forEach(item => {
        setTimeout(() => {
          item.remove()
        }, 5000)
      })
    }, 300)
  }

  localStorage.setItem(localStorageKey, JSON.stringify(wishlist));
  initWishlist();
};

// Get gender value
const getCookieValue = (name) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
};

// Build Wishlist
const buildWishlist = () => {
  const wishlistMain = document.querySelector('#wishlist-main');

  let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  const wishlistMainEmpty = wishlistMain.querySelector('#wishlist-main-empty');
  const wishlistMainProductList = document.querySelector('#wishlist-main-product-list');
  const wishlistMainTop = document.querySelector('.wishlist__top');

  wishlistMainProductList.innerHTML = '';

  if (wishlist.length === 0) {
    wishlistMainProductList.style.display = 'none';
    wishlistMainTop.style.display = 'none';
    wishlistMainEmpty.style.display = 'block';
  } else {
    const gender = getCookieValue('gender');

    let buildProductListItems = '';
    wishlist = wishlist.reverse();
    wishlist.forEach((product, index) => {
      let isOneSize = false;
      let isGenderWomen = false;
      let featuredImage = product.featured_image;
      let imageOver = product.image_over;

      if (product.variants[0].title === 'One size') {
        isOneSize = true;
      }

      if (gender && gender === 'women') {
        isGenderWomen = true;
        featuredImage = product.alt_featured_image;
        imageOver = product.alt_image_over;
      }

      buildProductListItems += `
        <div class="product product--wishlist js-wishlist-product">
          <a
            href="${product.url}${isGenderWomen ? '?view=women' : ''}"
            class="product__remove js-remove-from-wishlist btn-remove-from-wishlist"
            data-product-handle="${product.handle}"
          >
            <span class="product__cross"></span>
          </a>
        
          <div class="product__link-wrapper">
            <a href="${product.url}${isGenderWomen ? '?view=women' : ''}" class="product__link"></a>
        
            <div class="product__inner">
              <div class="product__image-wrapper">
                <img
                  alt="${product.title}"
                  class="product__image lazyload-fade lazyautosizes ls-is-cached lazyloaded"
                  sizes="238px"
                  src="${featuredImage}"
                />
                
                ${
                  imageOver
                    ? `
                      <img
                        alt="${product.title}"
                        class="product__image product__image--over lazyautosizes ls-is-cached lazyloaded"
                        sizes="238px"
                        src="${imageOver}"
                      />
                    `
                    : ''
                }
              </div>
        
              <div class="product__desc">
                <div class="product__tags">
                  ${
                    product.compare_at_price > product.price
                      ? `<div class="prod-tag prod-tag--red">-${Math.floor(
                          ((product.compare_at_price - product.price) * 100) / product.compare_at_price
                        )} %</div>`
                      : ''
                  }
                  ${
                    product.tags.includes('Sustainable')
                      ? `<div class="prod-tag prod-tag--green">Sustainable</div>`
                      : ''
                  }
                </div>
        
                <div class="product__title">
                  ${
                    product.title.toLowerCase().includes('gift card')
                    ? `${product.vendor} - ${product.title.replace('Freshlabels', 'Electronic')}`
                    : `${product.vendor} - ${product.title}`
                  }
                </div>
        
                <div class="product__prices">
                  ${
                    product.title.toLowerCase().includes('gift card')
                    ? `<div class="product__price">${egWishlistFormatMoneyHelper(Math.min(...product.variants.map(v => v.price)))} - ${egWishlistFormatMoneyHelper(Math.max(...product.variants.map(v => v.price)))}</div>`
                    : `
                      <div class="product__price">Now ${egWishlistFormatMoneyHelper(product.price)}</div>
                      ${
                        product.compare_at_price > product.price
                          ? `
                            <div class="product__price product__price--discounted">
                              ${egWishlistFormatMoneyHelper(product.compare_at_price)}
                            </div>
                            <div class="product__discount">
                              -${Math.floor(((product.compare_at_price - product.price) * 100) / product.compare_at_price)}%
                            </div>
                          `
                          : ''
                      }
                    `
                  }
                </div>
              </div>
            </div>
          </div>
          
          <div class="dropdown variant-dropdown ${isOneSize ? 'hidden': ''}">
            <input type="checkbox" class="dropdown__switch hidden" id="variant-switch-${index}" hidden />
            <label for="variant-switch-${index}" class="dropdown__options-filter">
              <ul class="dropdown__filter" role="listbox" tabindex="-1">
                <li class="dropdown__filter-selected" aria-selected="true">Choose size</li>
                <li>
                  <ul class="dropdown__select">
                    <li class="dropdown__select-option" role="option">Choose size</li>
                    ${product.variants
                      .map(item => {
                        let stockInfo = '';
                        if (!item.available) {
                          stockInfo = 'sold out';
                        }
                        return `
                          <li class="dropdown__select-option variant ${stockInfo.replace(' ', '')}" role="option" data-id="${item.id}">
                            ${item.title}
                            <span>${stockInfo}</span>
                          </li>
                        `;
                      })
                      .join('')
                    }
                  </ul>
                </li>
              </ul>
            </label>
          </div>
          
          <product-form class="product-form">
            <div class="product-form__error-message-wrapper" role="alert" hidden>
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon-error"
                viewBox="0 0 13 13"
              >
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2" />
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7" />
                <path
                  d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z"
                  fill="white"
                />
                <path
                  d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z"
                  fill="white"
                  stroke="#EB001B"
                  stroke-width="0.7"
                >
                </path>
              </svg>
              <span class="product-form__error-message"></span>
            </div>
            <form
              method="post"
              action="/cart/add"
              accept-charset="UTF-8"
              class="form"
              id="product-form-${product.variants[0].id}"
              enctype="multipart/form-data"
              novalidate="novalidate"
              data-type="add-to-cart-form"
            >
              <input class="variant-input" type="hidden" name="id" value="${product.variants[0].id}" />
              <div class="product-form__buttons">
                <button
                  type="submit"
                  name="add"
                  class="product-form__submit button button--full-width button--primary"
                  aria-haspopup="dialog"
                >
                  <span>Add to cart</span>
                  <div class="loading-overlay__spinner hidden">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="spinner"
                      viewBox="0 0 66 66"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </div>
            </form>
          </product-form>
        </div>
      `;
    });

    wishlistMainProductList.insertAdjacentHTML('afterbegin', buildProductListItems);

    document.querySelectorAll('.btn-remove-from-wishlist:not(.init)').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        btn.classList.add('init');

        wishlist = wishlist.filter((elem) => elem.handle !== btn.dataset.productHandle);
        localStorage.setItem(localStorageKey, JSON.stringify(wishlist));

        initWishlist();
        buildWishlist();
      });
    });

    document.querySelectorAll('.variant-dropdown').forEach((dropdown) => {
      const selectedOption = dropdown.querySelector('.dropdown__filter-selected');
      const variantOptions = Array.from(dropdown.querySelectorAll('.dropdown__select-option.variant'));
      const dropdownSwitch = dropdown.querySelector('.dropdown__switch');
      const targetInput = dropdown.nextElementSibling.querySelector('input.variant-input');
      variantOptions.forEach((option) => {
        option.addEventListener('click', (el) => {
          selectedOption.textContent = option.textContent;
          targetInput.value = option.dataset.id;
        });
      });
      document.addEventListener('click', (e) => {
        const el = e.target;
        if (el == dropdownSwitch) return;
        const dropdownHasChild = el.closest('.variant-dropdown .dropdown__filter');
        if (!dropdownHasChild) {
          dropdownSwitch.checked = false;
        }
      });
    });
  }
};
